import React, { useState, useRef, useCallback } from 'react'
import './style.css'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";

const HirePageSolutionSection = ({ content, shortHeading, mainHeading, description }) => {

    const sliderRef = useRef();

    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);

    const handlePrev = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slidePrev();
    }, []);

    const handleNext = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slideNext();
    }, []);

    const handleSlideChange = (swiper) => {
        setIsBeginning(swiper.isBeginning);
        setIsEnd(swiper.isEnd);
    };

    return (
        <>
            {/* Hire Page Solution Section */}
            <section className="hire-page-solution-section">
                <div className="container">
                    <div className="row align-items-center">
                        {/* Left image */}
                        <div className="col-lg-4 mb-4 mb-lg-0">
                            <div className="hire-page-solution-section-img">
                                <img src="/images/why-us-section/why-us-banner-image-old.avif" alt="Machine Learning Development Process" className="hire-solution-image-box" />
                            </div>
                        </div>
                        {/* Right content */}
                        <div className="col-lg-8">
                            <h2 className="low-top-heading">{shortHeading}</h2>
                            <h2 className="hire-page-solution-section-title mb-3">{mainHeading}</h2>
                            <p className="description-text">{description}</p>
                            {/* Swiper Slider */}
                            <div className="hire-page-solution-swiper">
                                {/* {content?.map((item, index) => {
                                    return
                                })} */}

                                <Swiper
                                    slidesPerView={"2.3"}
                                    spaceBetween={0}
                                    navigation={false}
                                    autoplay={{
                                        delay: 5000,
                                        disableOnInteraction: false,
                                        pauseOnMouseEnter: true,
                                    }}
                                    modules={[Navigation, Autoplay]}
                                    onSlideChange={handleSlideChange}
                                    className="mySwiper"
                                    ref={sliderRef}
                                    breakpoints={{
                                        // When window width is >= 320px
                                        425: {
                                            slidesPerView: 1,
                                            spaceBetween: 20,
                                        },
                                        375: {
                                            slidesPerView: 1,
                                            spaceBetween: 20,
                                        },
                                        320: {
                                            slidesPerView: 1,
                                            spaceBetween: 20,
                                        },
                                        768: {
                                            slidesPerView: 2,
                                            spaceBetween: 20,
                                        },
                                    }}
                                >
                                    {content?.map((item, index) => {
                                        return (
                                            <SwiperSlide key={index}>
                                                <div className="swiper-slide">
                                                    <div className="hire-page-solution-card">
                                                        <span className="hire-page-solution-number">{index + 1}</span>
                                                        <h5>{item?.title}</h5>
                                                        <p className='descripiton-text'>{item?.description}</p>
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        );
                                    })}
                                </Swiper>

                                {/* Swiper Navigation */}
                                <div className="hire-page-solution-navigation d-flex justify-content-end mt-4">
                                    <button onClick={handlePrev} className="hire-page-solution-prev btn btn-light rounded-circle me-2" style={{
                                        cursor: isBeginning ? "not-allowed" : "pointer",
                                    }}>
                                        <i className="fa fa-chevron-left" />
                                    </button>
                                    <button onClick={handleNext} className="hire-page-solution-next btn btn-light rounded-circle" style={{
                                        cursor: isBeginning ? "not-allowed" : "pointer",
                                    }}>
                                        <i className="fa fa-chevron-right" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default HirePageSolutionSection